import { searchSchema, gallerizedSearchSchema, searchRecommendedSchema, filterValuesSchema, filterConfigSchema } from '../../models/adSearch/morph.js';
import { searchResult, searchRecommendedResult, filterValues, filterConfig } from '../../models/adSearch/zod.js';
import { clientGet } from '../../utils/fetchwrapper.js';
import { processBody } from '../../utils/fetchwrapperUtils/responseProcessors.js';

const searchItems = (origin, params, environmentID, isProd = false) => clientGet({
    url: `${origin}/v1/search/items`,
    queryParams: params,
    sbtHeaders: { environmentID },
}).then(processBody(searchSchema, isProd ? null : searchResult));
const searchGallerized = (origin, params, environmentID, isProd = false) => clientGet({
    url: `${origin}/v1/search/items/gallerized`,
    queryParams: {
        ...params,
        lim: params.lim ?? 3,
    },
    sbtHeaders: { environmentID },
}).then(processBody(gallerizedSearchSchema, isProd ? null : searchResult));
const searchGeoboosted = (origin, params, environmentID, isProd = false) => clientGet({
    url: `${origin}/v1/search/items/geoboosted`,
    queryParams: {
        ...params,
        lim: params.lim ?? 5,
    },
    sbtHeaders: { environmentID },
}).then(processBody(searchSchema, isProd ? null : searchResult));
const searchRecommendedHp = (origin, params) => clientGet({
    url: `${origin}/v1/search/items/hp-recommended`,
    queryParams: { ...params, lim: params.lim ?? 20 },
}).then(processBody(searchSchema, searchResult));
const searchRecommendedDetail = (origin, urn) => clientGet({
    url: `${origin}/v1/search/items/detail-recommended`,
    queryParams: { urn, lim: 20 },
}).then(processBody(searchSchema, searchResult));
const searchRecommended = (origin, urn) => clientGet({
    url: `${origin}/v1/search/items/pro/recommender?urn=${urn}`,
}).then(processBody(searchRecommendedSchema, searchRecommendedResult));
const getFilterValues = (origin, uri, category) => {
    if (!uri.startsWith('/v1/values')) {
        return Promise.reject(new Error('Missing or invalid URI parameter'));
    }
    return clientGet({
        url: `${origin}${uri}`,
        queryParams: {
            category,
        },
    }).then(processBody(filterValuesSchema, filterValues));
};
const getFiltersConfig = (origin, categoryId, adType, timeoutMs, isProd = false) => {
    return clientGet({
        url: `${origin}/v1/search/categories/${categoryId}/ad_types/${adType}/filters`,
        timeoutMs,
    }).then(processBody(filterConfigSchema, isProd ? null : filterConfig));
};

export { getFilterValues, getFiltersConfig, searchGallerized, searchGeoboosted, searchItems, searchRecommended, searchRecommendedDetail, searchRecommendedHp };
//# sourceMappingURL=client.js.map
